module.exports = __webpack_public_path__ + "static/media/text_only@3x.b85f1125.png";